import React, { createContext, useContext } from 'react';

type SingleFormContextProps = {
  formIndex: number;
};

export const SingleFormContext = createContext<SingleFormContextProps>({} as SingleFormContextProps);

type SingleFormProviderProps = {
  children: React.ReactNode;
  formIndex?: number;
};

export const SingleFormProvider: React.FC<SingleFormProviderProps> = ({ children, formIndex = 0 }) => {
  return (
    <SingleFormContext.Provider
      value={{
        formIndex,
      }}
    >
      {children}
    </SingleFormContext.Provider>
  );
};

export const useSingleForm = (): SingleFormContextProps => useContext(SingleFormContext);
